import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatAgreementModel } from 'src/app/model/cat-agreement.model';
import { CatAgreementService } from 'src/app/services/cat-agreement.service';

@Component({
  selector: 'app-modal-cat-agreement',
  templateUrl: './modal-cat-agreement.component.html',
  styleUrls: ['./modal-cat-agreement.component.css']
})
export class ModalCatAgreementComponent implements OnInit {
  @Input() agreement: CatAgreementModel;
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private agreementService: CatAgreementService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  updateAgreementId = (value: any) => {
    const parsed = parseInt(value, 10);
    this.agreement.agreementId = isNaN(parsed) ? null : parsed;
  }
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.agreementIdError()) errors.push('Necesita capturar el ID mandante del convenio.');
    if (this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion
      this.agreement.description = this.agreement.description.toUpperCase().trim();
      this.agreementService.save(this.agreement)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El convenio se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar el convenio.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            const messageError = error && error.error && error.error.messageError;
            return of(this.toastr.error(messageError || 'Ocurrió un error al intentar guardar el convenio.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  agreementIdError = () => this.mode === 'create' && (this.agreement.agreementId === null || this.agreement.agreementId === undefined || this.agreement.agreementId <= 0);
  descriptionError = () => !this.agreement.description || this.agreement.description.trim() === '';
}
